import * as coreNewDocMethods from "app/client/ui/CoreNewDocMethods";
export const newDocMethods = coreNewDocMethods;
